import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function SelectCategoryGroups(props) {
  const {
    options,
    value,
    onHandleChange,
    className = "mb-2",
    isMulti = true,
    allowSelectAll = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const isMounted = useIsMounted();
  const [categoryGroups, setCategoryGroups] = useState();
  const { plantHex } = useParams();

  // > LOAD CATEGORY GROUPS //
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          axiosPath(
            plantHex
              ? "api_r_user_module_legalCompliance_evaluation_getCategoryGroups"
              : "api_r_user_module_globalLegalCompliance_evaluation_getCategoryGroups"
          ),
          { categoryGroups: options }
        );
        if (isMounted.current) setCategoryGroups(response.data);
      } catch (err) {}
    })();
  }, []);
  // < LOAD CATEGORY GROUPS //

  return (
    <AppMultiSelect
      options={categoryGroups}
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="category.groups" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="user" name="select.one.or.multiple.elements" />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      isLoading={!categoryGroups}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
